// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var _map = {"abort":"abort","afterprint":"afterprint","animationend":"animationend","animationiteration":"animationiteration","animationstart":"animationstart","beforeprint":"beforeprint","beforeunload":"beforeunload","blur":"blur","canplay":"canplay","canplaythrough":"canplaythrough","change":"change","click":"click","contextmenu":"contextmenu","copy":"copy","cut":"cut","dblclick":"dblclick","drag":"drag","dragend":"dragend","dragenter":"dragenter","dragleave":"dragleave","dragover":"dragover","dragstart":"dragstart","drop":"drop","durationchange":"durationchange","ended":"ended","error":"error","focus":"focus","focusin":"focusin","focusout":"focusout","fullscreenchange":"fullscreenchange","fullscreenerror":"fullscreenerror","hashchange":"hashchange","input":"input","invalid":"invalid","keydown":"keydown","keypress":"keypress","keyup":"keyup","load":"load","loadeddata":"loadeddata","loadedmetadata":"loadedmetadata","loadstart":"loadstart","message":"message","mousedown":"mousedown","mouseenter":"mouseenter","mouseleave":"mouseleave","mousemove":"mousemove","mouseover":"mouseover","mouseout":"mouseout","mouseup":"mouseup","mousewheel":"mousewheel","offline":"offline","online":"online","open_":"open","pagehide":"pagehide","pageshow":"pageshow","paste":"paste","pause":"pause","play":"play","playing":"playing","popstate":"popstate","progress":"progress","ratechange":"ratechange","resize":"resize","reset":"reset","scroll":"scroll","search":"search","seeked":"seeked","seeking":"seeking","select":"select","selectionchange":"selectionchange","show":"show","stalled":"stalled","storage":"storage","submit":"submit","suspend":"suspend","timeupdate":"timeupdate","toggle":"toggle","touchcancel":"touchcancel","touchend":"touchend","touchmove":"touchmove","touchstart":"touchstart","transitionend":"transitionend","unload":"unload","volumechange":"volumechange","waiting":"waiting","wheel":"wheel"};

var _revMap = {"abort":"abort","afterprint":"afterprint","animationend":"animationend","animationiteration":"animationiteration","animationstart":"animationstart","beforeprint":"beforeprint","beforeunload":"beforeunload","blur":"blur","canplay":"canplay","canplaythrough":"canplaythrough","change":"change","click":"click","contextmenu":"contextmenu","copy":"copy","cut":"cut","dblclick":"dblclick","drag":"drag","dragend":"dragend","dragenter":"dragenter","dragleave":"dragleave","dragover":"dragover","dragstart":"dragstart","drop":"drop","durationchange":"durationchange","ended":"ended","error":"error","focus":"focus","focusin":"focusin","focusout":"focusout","fullscreenchange":"fullscreenchange","fullscreenerror":"fullscreenerror","hashchange":"hashchange","input":"input","invalid":"invalid","keydown":"keydown","keypress":"keypress","keyup":"keyup","load":"load","loadeddata":"loadeddata","loadedmetadata":"loadedmetadata","loadstart":"loadstart","message":"message","mousedown":"mousedown","mouseenter":"mouseenter","mouseleave":"mouseleave","mousemove":"mousemove","mouseover":"mouseover","mouseout":"mouseout","mouseup":"mouseup","mousewheel":"mousewheel","offline":"offline","online":"online","open":"open_","pagehide":"pagehide","pageshow":"pageshow","paste":"paste","pause":"pause","play":"play","playing":"playing","popstate":"popstate","progress":"progress","ratechange":"ratechange","resize":"resize","reset":"reset","scroll":"scroll","search":"search","seeked":"seeked","seeking":"seeking","select":"select","selectionchange":"selectionchange","show":"show","stalled":"stalled","storage":"storage","submit":"submit","suspend":"suspend","timeupdate":"timeupdate","toggle":"toggle","touchcancel":"touchcancel","touchend":"touchend","touchmove":"touchmove","touchstart":"touchstart","transitionend":"transitionend","unload":"unload","volumechange":"volumechange","waiting":"waiting","wheel":"wheel"};

function tToJs(param) {
  return _map[param];
}

function tFromJs(param) {
  return _revMap[param];
}

var _map$1 = {"click":"click","contextmenu":"contextmenu","dblclick":"dblclick","mousedown":"mousedown","mouseenter":"mouseenter","mouseleave":"mouseleave","mousemove":"mousemove","mouseout":"mouseout","mouseover":"mouseover","mouseup":"mouseup"};

function mouseToJs(param) {
  return param;
}

function mouseFromJs(param) {
  return _map$1[param];
}

var _map$2 = {"keydown":"keydown","keypress":"keypress","keyup":"keyup"};

function keyboardToJs(param) {
  return param;
}

function keyboardFromJs(param) {
  return _map$2[param];
}

var _map$3 = {"beforeinput":"beforeinput","input":"input"};

function inputToJs(param) {
  return param;
}

function inputFromJs(param) {
  return _map$3[param];
}

var _map$4 = {"change":"change"};

function changeToJs(param) {
  return param;
}

function changeFromJs(param) {
  return _map$4[param];
}

var _map$5 = {"copy":"copy","cut":"cut","paste":"paste"};

function clipboardToJs(param) {
  return param;
}

function clipboardFromJs(param) {
  return _map$5[param];
}

var _map$6 = {"drag":"drag","dragend":"dragend","dragenter":"dragenter","dragleave":"dragleave","dragover":"dragover","dragstart":"dragstart","drop":"drop"};

function dragToJs(param) {
  return param;
}

function dragFromJs(param) {
  return _map$6[param];
}

var _map$7 = {"wheel":"wheel"};

function wheelToJs(param) {
  return param;
}

function wheelFromJs(param) {
  return _map$7[param];
}

var _map$8 = {"focus":"focus","focusin":"focusin"};

function focusToJs(param) {
  return param;
}

function focusFromJs(param) {
  return _map$8[param];
}

var _map$9 = {"blur":"blur","focusout":"focusout"};

function blurToJs(param) {
  return param;
}

function blurFromJs(param) {
  return _map$9[param];
}

exports.tToJs = tToJs;
exports.tFromJs = tFromJs;
exports.mouseToJs = mouseToJs;
exports.mouseFromJs = mouseFromJs;
exports.keyboardToJs = keyboardToJs;
exports.keyboardFromJs = keyboardFromJs;
exports.inputToJs = inputToJs;
exports.inputFromJs = inputFromJs;
exports.changeToJs = changeToJs;
exports.changeFromJs = changeFromJs;
exports.clipboardToJs = clipboardToJs;
exports.clipboardFromJs = clipboardFromJs;
exports.dragToJs = dragToJs;
exports.dragFromJs = dragFromJs;
exports.wheelToJs = wheelToJs;
exports.wheelFromJs = wheelFromJs;
exports.focusToJs = focusToJs;
exports.focusFromJs = focusFromJs;
exports.blurToJs = blurToJs;
exports.blurFromJs = blurFromJs;
/* No side effect */
